<ul
  [ngClass]="{
    'navbar': authService.isReadOnly,
    'navbar-nav bg-gradient-primary sidebar sidebar-light accordion': authService.hasAccess(Role.CustomerAdmin)
  }"
  [style.margin-bottom.px]="authService.isReadOnly ? -18 : undefined"
  id="accordionSidebar">

  <!-- Nav Item - Dashboard -->
  <li (click)="removeBack()" class="nav-item">
    <a class="nav-link" [routerLink]="['/dashboard']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa fa-fw fa-tachometer-alt"></i>
      <span>Dashboard</span></a>
    </li>

    <!-- Nav Item - Pages Collapse Menu -->

    @if (authService.hasAccess(Role.SuperAdmin)) {
      <li class="nav-item" [ngClass]="(activeSubitem=='partner') ? 'active':''">
        <a class="nav-link" href="javascript:;" [ngClass]="(activeSubitem=='partner') ? '':'collapsed'" (click)="openSubitems($event, 'partner')" (mouseenter)="openSubitems($event, 'partner')" data-toggle="collapse">
          <i class="fas fa-fw fa-handshake"></i>
          <span>Partner Accounts</span>
        </a>
        <div id="collapseTwo" class="collapse" [ngClass]="(activeSubitem=='partner') ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <a class="collapse-item" [routerLink]="['/dashboard/partner/new']" (click)="hideSubmenu()">Create new partner</a>
            <a class="collapse-item" [routerLink]="['/dashboard/partner/list']" (click)="hideSubmenu()">List all partners</a>
          </div>
        </div>
      </li>
    }

    @if (authService.isPartnerAdmin) {
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/partner/' + partnerService.partner.id + '/scheme']">
          <i class="fas fa-fw fa-palette"></i>
          <span>Partner Scheme</span>
        </a>
      </li>
    }

    @if (authService.hasAccess(Role.PartnerAdmin)) {
      <li class="nav-item" [ngClass]="(activeSubitem=='customer') ? 'active':''">
        <a class="nav-link" href="javascript:;" [ngClass]="(activeSubitem=='customer') ? '':'collapsed'" (click)="openSubitems($event, 'customer')" (mouseenter)="openSubitems($event, 'customer')" data-toggle="collapse">
          <i class="fa fa-fw fa-user"></i>
          <span>Customer Accounts</span>
        </a>
        <div id="collapseTwo" class="collapse" [ngClass]="(activeSubitem=='customer') ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <a class="collapse-item" [routerLink]="['/dashboard/customer/new']" (click)="hideSubmenu()">Create new customer</a>
            <a class="collapse-item" [routerLink]="['/dashboard/customer/list']" (click)="hideSubmenu()">List all customers</a>
          </div>
        </div>
      </li>
    }
    @if (authService.hasAccess(Role.CustomerAdmin)) {
      <li class="nav-item" [ngClass]="(activeSubitem=='usermgt') ? 'active':''">
        <a class="nav-link" href="javascript:;" [ngClass]="(activeSubitem=='usermgt') ? '':'collapsed'" (click)="openSubitems($event, 'usermgt')" (mouseenter)="openSubitems($event, 'usermgt')" data-toggle="collapse">
          <i class="fa fa-fw fa-users"></i>
          <span>User Management</span>
        </a>
        <div id="collapseOne" class="collapse" [ngClass]="(activeSubitem=='usermgt') ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <a class="collapse-item" [routerLink]="['/dashboard/user/new']" (click)="hideSubmenu()">Create user</a>
            <a class="collapse-item" [routerLink]="['/dashboard/user/list']" (click)="hideSubmenu()">List all user</a>
          </div>
        </div>
      </li>
    }
    <!-- Nav Item - Utilities Collapse Menu -->
    @if (authService.hasAccess(Role.CustomerAdmin)) {
      <li class="nav-item" [ngClass]="(activeSubitem=='project') ? 'active':''">
        <a class="nav-link" href="javascript:;" [ngClass]="(activeSubitem=='project') ? '':'collapsed'" (click)="openSubitems($event, 'project')" (mouseenter)="openSubitems($event, 'project')" data-toggle="collapse">
          <i class="fa fa-fw fa-file-powerpoint"></i>
          <span>Projects</span>
        </a>
        <div id="collapseTwo" class="collapse" [ngClass]="(activeSubitem=='project') ? 'show':''">
          <div class="bg-white py-2 collapse-inner rounded">
            <a class="collapse-item" [routerLink]="['/dashboard/project/new']" (click)="hideSubmenu()">Create new project</a>
            <a class="collapse-item" [routerLink]="['/dashboard/project/list']" (click)="hideSubmenu()">List all projects</a>
          </div>
        </div>
      </li>
    }

    @if (treeview) {
      <app-treeview></app-treeview>
    }
    <!-- Divider -->
    @if (authService.hasAccess(Role.CustomerAdmin)) {
      <hr class="sidebar-divider d-none d-md-block">
    }

    <li class="nav-item" [class.disabled]="activeProject === null">
      <a class="nav-link" [routerLink]="'/dashboard/file-explorer'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <i class="fas fa-folder"></i>
        <span>Explorer</span>
      </a>
    </li>

    <li class="nav-item" [class.disabled]="activeProject === null">
      <a class="nav-link" [routerLink]="'/dashboard/filesearch'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <i class="fas fa-search"></i>
        <span>Search</span>
      </a>
    </li>

    <li class="nav-item" [class.disabled]="activeProject === null">
      <a class="nav-link" [routerLink]="activeProject ? ['/dashboard/project', activeProject.id, 'imports'] : null" [state]="{ data: { project: activeProject } }" routerLinkActive="active">
        <i class="fas fa-file-import"></i>
        <span>Media Imports</span>
      </a>
    </li>

    @if (authService.hasAccess(Role.SuperAdmin)) {
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/deleted']" routerLinkActive="active">
          <i class="fas fa-fw fa-trash-restore"></i>
          <span>Deleted Records</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/dashboard/audit-logs']" routerLinkActive="active">
          <i class="fas fa-fw fa-clipboard-list"></i>
          <span>Audit Logs</span>
        </a>
      </li>
    }

  </ul>